export const FETCH_BID_SESSION_REQUEST = 'FETCH_BID_SESSION_REQUEST';
export const FETCH_BID_SESSION_FAILURE = 'FETCH_BID_SESSION_FAILURE';
export const FETCH_BID_SESSION_SUCCESS = 'FETCH_BID_SESSION_SUCCESS';
export const UPDATE_BID_SESSION_SUCCESS = 'UPDATE_BID_SESSION_SUCCESS';
export const FETCH_BID_MODE_SUCCESS = 'FETCH_BID_MODE_SUCCESS';
export const CLEAR_DATA = 'CLEAR_DATA';
